import styled from '@emotion/styled';
import { Stack } from '@hotjar/hotsauce';

import { SurveyStatus } from '../Actions/SurveyStatus/SurveyStatus';
import type { SurveyStatusProps } from '../Actions/SurveyStatus/SurveyStatus';
import { Summary } from './Summary';
import type { SummaryProps } from './Summary';
import { SummaryActions } from './SummaryActions';
import type { SummaryActionProps } from './SummaryActions';

const SectionWrapper = styled(Stack)`
  max-width: 800px;
`;

const StatusActionsWrapper = styled(Stack)`
  text-align: center;
  justify-content: center;
`;

export type SummarySectionAllCommonProps = SummaryProps & SummaryActionProps & SurveyStatusProps;

export interface SummarySectionProps extends SummarySectionAllCommonProps {
  areAllVisibleSectionsValid: boolean;
}

export const SummarySection = (props: SummarySectionProps): JSX.Element => {
  const {
    areAllVisibleSectionsValid,
    name,
    description,
    questions,
    location,
    targeting,
    targetingPercentage,
    forwardingEmailAddresses,
    forwardingEmailEnabled,
    forwardingSlackChannels,
    forwardingSlackEnabled,
    forwardingMsTeamsWebhookUrls,
    forwardingMsTeamsEnabled,
    forwardingWebhooksUrls,
    forwardingWebhooksEnabled,
    errors,
    mode,
    onNavigateClicked,
    reloadPreview,
    isActive,
    onStatusChange,
    isSaving,
    onCopy,
    onSave,
  } = props;

  return (
    <SectionWrapper spacing="x4" direction="column">
      <Summary
        name={name}
        description={description}
        questions={questions}
        location={location}
        targeting={targeting}
        targetingPercentage={targetingPercentage}
        forwardingEmailAddresses={forwardingEmailAddresses}
        forwardingEmailEnabled={forwardingEmailEnabled}
        forwardingSlackChannels={forwardingSlackChannels}
        forwardingSlackEnabled={forwardingSlackEnabled}
        forwardingMsTeamsWebhookUrls={forwardingMsTeamsWebhookUrls}
        forwardingMsTeamsEnabled={forwardingMsTeamsEnabled}
        forwardingWebhooksUrls={forwardingWebhooksUrls}
        forwardingWebhooksEnabled={forwardingWebhooksEnabled}
        errors={errors}
        mode={mode}
        onNavigateClicked={onNavigateClicked}
        reloadPreview={reloadPreview}
      />
      {areAllVisibleSectionsValid && (
        <StatusActionsWrapper spacing="x4" direction="column">
          <SurveyStatus isActive={isActive} onStatusChange={onStatusChange} />
          <SummaryActions mode={mode} isSaving={isSaving} onCopy={onCopy} onSave={onSave} />
        </StatusActionsWrapper>
      )}
    </SectionWrapper>
  );
};
